import useDelete from '~/lib/useDelete';
import { setWaitlistListQuery } from '~/lib/Queries';
import * as Toast from '~/lib/Toast';
import StartEndDateTime from '~/components/forms/StartEndDateTime';
import { formatDateTimeLong } from '~/lib/DateTime';
import DotDotDotMenu from '~/components/DotDotDotMenu';
import ClientDetails from '~/components/clients/ClientDetails.jsx';
import { useState } from 'react';

const WaitlistEntry = ({ entry, isFirst, hideTime, hideClient }) => {
    const [selectedClient, setSelectedClient] = useState(null);
    const { saveDelete, isDeleting } = useDelete(
        `/waitlist/${entry.id}/delete`,
    );

    function doDelete() {
        saveDelete().then(result => {
            setWaitlistListQuery(result);
            Toast.success(`Successfully removed ${entry.name} from waitlist`);
        });
    }

    return (
        <>
            <div
                className={`flex items-center justify-between py-3 pr-4 ${!isFirst ? 'border-t' : ''}`}
            >
                <div
                    className={`sm:flex items-center ${!!entry.client ? 'cursor-pointer' : ''}`}
                    onClick={() => setSelectedClient(entry.client)}
                >
                    {!hideClient && (
                        <div className="sm:min-w-48">
                            {entry.name}
                            <div className="text-sm text-gray-500">
                                {entry.email}
                            </div>
                        </div>
                    )}

                    {!hideTime && (
                        <div>
                            {entry.event_type?.name}
                            <div className="text-sm text-gray-500">
                                {entry.is_range && (
                                    <StartEndDateTime
                                        start={entry.start}
                                        end={entry.end}
                                    />
                                )}
                                {!entry.is_range &&
                                    formatDateTimeLong(entry.start)}
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex items-center justify-end">
                    {entry.notified?.length > 0 && (
                        <div className="tag bg-green-100 !text-green-600 mr-4">
                            Notified
                        </div>
                    )}
                    {!entry.notified?.length && (
                        <div className="tag bg-yellow-100 !text-yellow-600 mr-4">
                            Waiting
                        </div>
                    )}

                    <DotDotDotMenu
                        options={[
                            {
                                name: isDeleting ? 'Deleting...' : 'Delete',
                                isDelete: true,
                                onClick: doDelete,
                            },
                        ]}
                    />
                </div>
            </div>
            <ClientDetails
                client={selectedClient}
                onClose={() => setSelectedClient(null)}
                refetch={() => null}
            />
        </>
    );
};

export default WaitlistEntry;
